<nz-collapse nzGhost>
  <nz-collapse-panel nzActive [nzHeader]="to.label">
    <ng-container #fieldComponent></ng-container>
  </nz-collapse-panel>
</nz-collapse>
